import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e6145ee&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2e6145ee&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6145ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e6145ee')) {
      api.createRecord('2e6145ee', component.options)
    } else {
      api.reload('2e6145ee', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2e6145ee&scoped=true", function () {
      api.rerender('2e6145ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/productAssociationForm/index.vue"
export default component.exports